import { defineComponent, inferProps, ScrollPane, ShadowContainer, type ReactiveComponent } from "vue-utils"

import type { MarriageClaimInitialData } from "@/models/marriages/MarriageClaimInitialData"
import { css } from "vite-css-in-js"
import { provide } from "vue"
import DetailNavigation from "./DetailNavigation"
import MarriageClaimFormSection from "./Sections/MarriageClaimFormSection"
import { AllFormSections } from "./Sections/sections"
import { EditingMarriageClaimInjectionKey, EditingMarriageClaimState } from "./state"

interface Props {
	claimData: MarriageClaimInitialData
}

const pageLayout = css`
	display: grid;
	grid-template-columns: 1fr 18rem;
	align-items: stretch;
	gap: 0.5rem;
	height: 100%;
`

const contentLayout = css`
	scroll-behavior: smooth;
	overflow: auto;
`

const DetailContent: ReactiveComponent<Props> = (props) => {
	const state = new EditingMarriageClaimState(props.claimData)
	provide(EditingMarriageClaimInjectionKey, state)

	return () => (
		<div class={pageLayout}>
			<ScrollPane class="w-full flex-grow-1">
				<ShadowContainer class={contentLayout}>
					{AllFormSections.map((section) => (
						<MarriageClaimFormSection key={section.id} section={section} />
					))}
				</ShadowContainer>
			</ScrollPane>
			<DetailNavigation sections={AllFormSections} claimData={props.claimData} />
		</div>
	)
}
export default defineComponent(DetailContent, inferProps<Props>())
